export const globalFunc = {
    slugify: (text = '', ampersand = "and") => {
      const a = "àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧğşı";
      const b = "aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzhgsi";
      const p = new RegExp(a.split("").join("|"), "g");
  
      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-") // Replace whitespace and underscore with single hyphen
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special chars
        .replace(/&/g, `-${ampersand}-`) // Replace ampersand with custom word
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-") // Replace multiple hyphens with single
        .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
    },
  
    isURL: (str) => {
      return /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/.test(str);
    },
  
    copyTextToClipboard: (text) => {
      navigator.clipboard.writeText(text);
    },
  
    haversineDistance(loc1, loc2, unit = "km") {
      const isLoc1Null = Object.values(loc1).some((value) => value === null);
      const isLoc2Null = Object.values(loc2).some((value) => value === null);
      if (isLoc1Null || isLoc2Null) {
        return null;
      }
  
      // var R = 3958.8;  // Radius of the Earth in miles
      // var R = 6371;    // Radius of the Earth in KM
  
      var R = unit == "mi" ? 3958.8 : 6371;
      var rlat1 = loc1.lat * (Math.PI / 180); // Convert degrees to radians
      var rlat2 = loc2.lat * (Math.PI / 180); // Convert degrees to radians
      var difflat = rlat2 - rlat1; // Radian difference (latitudes)
      var difflon = (loc2.lng - loc1.lng) * (Math.PI / 180); // Radian difference (longitudes)
  
      var d =
        2 *
        R *
        Math.asin(
          Math.sqrt(
            Math.sin(difflat / 2) * Math.sin(difflat / 2) +
              Math.cos(rlat1) *
                Math.cos(rlat2) *
                Math.sin(difflon / 2) *
                Math.sin(difflon / 2)
          )
        );
      return d;
    },
  
    fixVAT(vatNumber) {
      if (typeof vatNumber === 'undefined' || vatNumber === null) {
        return null;
      }
  
      // Remove non-digit characters
      vatNumber = vatNumber.replace(/\D/g, '');
  
      // If vatNumber is 9 characters long, add '0' at the beginning if it's not '0'.
      if (vatNumber.length === 9) {
        vatNumber = vatNumber.replace(/^(?!0)/, '0');
      }
  
      // If vatNumber has a length of 11 characters, remove leading zeros.
      if (vatNumber.length === 11) {
        vatNumber = vatNumber.replace(/^0+/, '');
      }
  
      return vatNumber;
    },
  
    replaceEmptyStringsWithNull(obj) {
      return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [
          k,
          v === ""
            ? null
            : v && typeof v === "object"
            ? replaceEmptyStringsWithNull(v)
            : v,
        ])
      );
    },
  };

export const globalVar = {
    countries: [
      { value: 1, label: "Belgium", code: "BEL", iso2: "be"},
      { value: 2, label: "Netherlands", code: "NLD", iso2: "nl"},
    ],
    
    locales: [
      'nl',
      'en',
      'fr'
    ],
  };